// extracted by mini-css-extract-plugin
module.exports = {"panel":"sign-up-tab-panel_panel__W96Zb","panelWithConsent":"sign-up-tab-panel_panelWithConsent__uGSVC","divider":"sign-up-tab-panel_divider__hQeVy"};